import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
//import { StorageService } from '../..//managers/storage.service';
import { StorageService } from '../../service/managers/storage.service';
import { Config } from '../component_dependent/config';

@Injectable({
  providedIn: 'root'
})
export class VoiceBatchService extends Config {

  constructor(private httpClient: HttpClient, private storage: StorageService) {
    super();
  }

   public uploadVoiceDetails(file): Observable<any> {
    var url = "upload_batch_detail";
    return this.httpClient.post(this.BASE_URL + url, file,this.storage.getHeaders());
  }

  public getBatch(batch_id){
    var url = "get_batch?batch_id=" + batch_id
    return this.httpClient.get(this.BASE_URL + url,this.storage.getHeaders())
  }
  public getVoiceBatch(maxItemsPerPage,page,keyword){
     var url = "get_batch_list?maxItemsPerPage=" + maxItemsPerPage + "&page=" + page + "&keyword=" + keyword
     return this.httpClient.get(this.BASE_URL + url,this.storage.getHeaders());
  }

  public getVoiceDetails(batch_id,maxItemsPerPage,page,keyword){
    var url ="get_batch_call_details"
    if (maxItemsPerPage != null) {
      url += ("?maxItemsPerPage=" + maxItemsPerPage + (keyword != null ? "&keyword=" + keyword : "") + "&page=" + page + "&batch_id=" + batch_id);
    }
    return this.httpClient.get(this.BASE_URL + url, this.storage.getHeaders())
  }

  public callSponsors(batch_id){
     var url = "callallsponsors"
     
     if (batch_id != null) {
      url += ("?batch_id=" + batch_id);
    }

     return this.httpClient.get(this.BASE_URL + url,this.storage.getHeaders())
  }

  public callSponsorsBySchedule(data){
    var url = "callsponsorbyschedule"

    return this.httpClient.post(this.BASE_URL + url, data,this.storage.getHeaders())
  }

  public getCallHistory(batch_detail_id){
    var url="get_call_history"
    if (batch_detail_id != null) {
      url += ("?batch_detail_id=" + batch_detail_id);
    }
  
    return this.httpClient.get(this.BASE_URL + url,this.storage.getHeaders())
  }

}
